import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import moment from 'moment';
import { LocationsProvider } from '../../providers/locations/locations';
import { EventsProvider } from '../../providers/events/events';
import { AppState } from '../../config/state';




@Component({
  selector: 'co-event-desktop-filter-sidebar',
  templateUrl: 'co-event-desktop-filter-sidebar.html'
})
export class CoEventDesktopFilterSidebarComponent {
  filterShow: string;
  text: string;
  timeRangeSidebar: any = { lower: 0, upper: 24 };
  displayTime: any = { lower: moment().hour(this.timeRangeSidebar.lower).startOf('hour'), upper: moment().hour(this.timeRangeSidebar.upper).startOf('hour') };
  allLocations: any;
  includedLocations: any = {};
  displayIncludedLocations: any = [];
  eventAges: any;
  includedAges: any = {};
  displayIncludedAges: any = [];
  eventTypes: any;
  includedTypes: any = {};
  displayIncludedTypes: any = [];
  filterKeyword: any;
  currentFilters: any;
  keywordTextValue: string;
  searchTags: any;
  listOffset: any = { locationList: 0, agesList: 0, eventTypesList: 0 }
  showList: any = { locationList: false, agesList: false, eventTypesList: false };
  allOptionsSelectedFor: { locations: boolean, ages: boolean, eventTypes: boolean } = { locations: true, ages: true, eventTypes: true };
  @Output() sendSidebarFilters = new EventEmitter<any>();
  @ViewChild('locationListExpandButton') locationListExpandButton;
  @ViewChild('eventTypesListExpandButton') eventTypesListExpandButton;
  @ViewChild('agesListExpandButton') agesListExpandButton;

  constructor(public viewCtrl: ViewController, public navParams: NavParams, public locationsProvider: LocationsProvider, public eventsProvider: EventsProvider, private state: AppState) {
    this.filterShow = this.navParams.data.data;
    locationsProvider.getLocations().then((res) => {
      this.allLocations = res;
      let locationArray = [];
      this.allLocations.forEach(loc => {
        if (this.navParams.data.location === loc.id) {
          this.includedLocations[loc.id] = true;
        } else {
          this.includedLocations[loc.id] = false;
        }
        locationArray.push(loc.id)
        this.displayIncludedLocations.push({ id: loc.id, info: loc });
      });
      if (!this.navParams.data.location) {
        this.allOptionsSelectedFor.locations = true;
      } else {
        this.allOptionsSelectedFor.locations = false;
      }
    });
    this.getEventSettings();
  };

  ngOnInit() {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  getEventSettings() {
    this.eventAges = this.state.eventColors.ages;
    let ageArray = [];
    this.eventAges.forEach(age => {
      this.includedAges[age.name] = false;
      ageArray.push(age.name)
      this.displayIncludedAges.push(age.name);
    });
    this.allOptionsSelectedFor.ages = true;

    this.eventTypes = this.state.eventColors.types;
    this.searchTags = this.state.eventColors.types;
    let eventsArray = [];
    this.eventTypes.forEach(eventType => {
      if (this.navParams.data.eventType === eventType.name) {
        this.includedTypes[eventType.name] = true;
      } else {
        this.includedTypes[eventType.name] = false;
      }
      eventsArray.push(eventType.name);
      this.displayIncludedTypes.push(eventType.name);
    });
    if (!this.navParams.data.eventType) {
      this.allOptionsSelectedFor.eventTypes = true;
    } else {
      this.allOptionsSelectedFor.eventTypes = false;
    }
  }

  expandDropdown(event, box) {
    let button;
    switch (box) {
      case ('locationList'):
        button = this.locationListExpandButton.nativeElement.offsetTop;
        break;
      case ('agesList'):
        button = this.agesListExpandButton.nativeElement.offsetTop;
        break;
      case ('eventTypesList'):
        button = this.eventTypesListExpandButton.nativeElement.offsetTop;
        break;
      default:
        console.log("list doesn\'t exist, does it need to be added?", event, box);
        break;
    }
    this.listOffset[box] = button + 30 + 'px';
    if (this.showList[box]) {
      this.showList[box] = false;
    } else if (!this.showList[box]) {
      Object.keys(this.showList).forEach(list => {
        this.showList[list] = false;
      })
      this.showList[box] = true;
    }
  }


  setKeyword(event) {
    if (event && event.value.length > 0) {
      this.filterKeyword = event.value.toLowerCase();
      this.sendFilters('keyword', this.filterKeyword, true);
    } else {
      this.filterKeyword = ""
      this.sendFilters('keyword', this.filterKeyword, true);
    }
  }

  clickForAllLocations(event) {
    this.allOptionsSelectedFor.locations = true;
  }

  clickForAllAges(event) {
    this.allOptionsSelectedFor.ages = true;
  }

  clickForAllTypes(event) {
    this.allOptionsSelectedFor.eventTypes = true;
  }

  chooseAllLocations(event) {
    if (event.value) {
      let locationArray = [];
      Object.keys(this.includedLocations).forEach(loc => {
        this.includedLocations[loc] = false;
        locationArray.push(loc);
      });
      this.sendFilters('location', locationArray, true);
      this.allOptionsSelectedFor.locations = true;
    };
  }

  getEventColor(eventType) {
    try {
      let eventTypeObject = this.searchTags.find(object => object.name === eventType);
      return eventTypeObject.color;
    } catch (ex) {
      return "green";
    };
  }

  chooseAllAges(event) {
    if (event.value) {
      let agesArray = [];
      Object.keys(this.includedAges).forEach(age => {
        this.includedAges[age] = false;
        agesArray.push(age);
      });
      this.sendFilters('ages', agesArray, true);
      this.allOptionsSelectedFor.ages = true;
    };
  }

  chooseAllTypes(event) {
    if (event.value) {
      let typesArray = [];
      Object.keys(this.includedTypes).forEach(eventType => {
        this.includedTypes[eventType] = false;
        typesArray.push(eventType);
      });
      this.sendFilters('eventType', typesArray, true);
      this.allOptionsSelectedFor.eventTypes = true;
    };
  }

  checkIfAllSelected(inputArray, filterType) {
    if (inputArray.length != 0) {
      return false;
    } else {
      return true;
    };
  }

  setLocations(event) {
    let locationArray = [];
    for (let location in this.includedLocations) {
      this.includedLocations[location] === true ? locationArray.push(location) : false;
    };
    this.sendFilters('location', locationArray, true);
    this.allOptionsSelectedFor.locations = this.checkIfAllSelected(locationArray, 'location');
    if (event.value) {
      this.allOptionsSelectedFor.locations = false;
    } else if (!event.value && locationArray.length === 0) {
      this.chooseAllLocations('');
      this.allOptionsSelectedFor.locations = true;
    } else {
    };
  }

  setAges(event) {
    let ageArray = [];
    for (let age in this.includedAges) {
      this.includedAges[age] === true ? ageArray.push(age) : false;
    };
    this.sendFilters('ages', ageArray, true);
    this.allOptionsSelectedFor.ages = this.checkIfAllSelected(ageArray, 'ages');
    if (event.value) {
      this.allOptionsSelectedFor.ages = false;
    } else if (!event.value && ageArray.length === 0) {
      this.chooseAllAges('');
      this.allOptionsSelectedFor.ages = true;
    } else {
    };
  }

  setEventType(event) {
    let eventTypeArray = [];
    for (let eventType in this.includedTypes) {
      this.includedTypes[eventType] === true ? eventTypeArray.push(eventType) : false;
    };
    this.sendFilters('eventType', eventTypeArray, true);
    this.allOptionsSelectedFor.eventTypes = this.checkIfAllSelected(eventTypeArray, 'eventTypes')
    if (event.value) {
      this.allOptionsSelectedFor.eventTypes = false;
    } else if (!event.value && eventTypeArray.length === 0) {
      this.chooseAllAges('');
      this.allOptionsSelectedFor.ages = true;
    } else {
    };
  }




  // resetAll(event){
  // this.close("resetAll","",false);
  // }

  sendFilters(tab, info, active) {
    let params = { type: tab, stats: info, on: active };
    this.sendSidebarFilters.emit(params);
  };

  onChange(event) {
    this.displayTime = { lower: moment().hour(this.timeRangeSidebar.lower).startOf('hour'), upper: moment().hour(this.timeRangeSidebar.upper).startOf('hour') }
    this.sendFilters('time', this.timeRangeSidebar, true);
  };


}



// WEBPACK FOOTER //
// ./src/components/co-event-desktop-filter-sidebar/co-event-desktop-filter-sidebar.ts